import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const taskImporterSelectors = importerSelectors(
  'task.importer',
);

export default taskImporterSelectors;
